import {
  Box,
  Center,
  Image,
  SimpleGrid,
  Text
} from "@chakra-ui/react";
import SectionHeading from "./sectionHeading";
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function HowCanHelp() {
  return (
    <Box
      color={"white"}
    >
      <LineSection />

      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }}>
        <Box
          bgImage={"img/iot-micro-controller-nano-electronic-board.webp"}
          backgroundSize={"cover"}
          backgroundPosition={"center"}
          display={{ base: "flex", md: "none", xl: "flex" }}
        >
        </Box>

        <Box
          pt={{ base: 10 }}
        >
          <Box
            w={{ base: "full", md: "full", xl: "2xl" }}
          >
            <SectionHeading
              title="How we can help"
              align="end"
            />
          </Box>
          <Text
            w={{ base: "full", md: "full", xl: "2xl" }}
            align={"end"}
            py={{ base: 3, md: 4, xl: 10 }}
            px={{ base: 4, md: 6 }}
            fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
          >
            <Lang text="AppOX provides resources and devices necessary to carry out the practices and activities in these study groups, in order to help them overcome the difficulties they face to finance themselves." />
          </Text>
          <Center>
            <Image
              src="img/iot-micro-controller-nano-electronic-board.webp"
              w='98%'
              borderRadius={30}
              objectFit='cover'
              display={{base:"flex", md:"none"}}
            />
          </Center>
          <Text
            w={{ base: "full", md: "full", xl: "2xl" }}
            align={"end"}
            pt={{ base: 3, md: 4, xl: 10 }}
            pb={{ base: 20, md: 40 }}
            px={{ base: 4, md: 6 }}
            fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
          >
            <Lang text="In addition, AppOX is committed to fostering enthusiasm and passion for technology, so we offer our expertise to provide lectures and, conferences to young people passionate about technology." />
          </Text>

        </Box>
      </SimpleGrid>

    </Box>
  );
}